import { useEffect, useRef, useState } from 'preact/hooks';

export function FilterSelect({ label, value, options, onChange, disabled = false }) {
  const normalizedValue = value == null ? '' : String(value);
  const matched = options.find((option) => String(option.value) === normalizedValue);
  const safeValue = matched ? String(matched.value) : '';
  const selectedLabel = matched?.label
    || options.find((option) => String(option.value) === '')?.label
    || options[0]?.label
    || '';

  return (
    <label className="pp-filter-field">
      {label ? <span>{label}</span> : null}
      <select
        key={`${safeValue}::${selectedLabel}`}
        value={safeValue}
        onChange={(event) => onChange(event.currentTarget.value)}
        disabled={disabled}
      >
        {options.map((option, index) => (
          <option key={`${String(option.value)}::${option.label}::${index}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}

export function FilterCheckboxList({
  label,
  options,
  selectedValues,
  onToggle,
  onSelectAll,
  disabled = false,
  placeholder = 'Tümü',
}) {
  const selectedSet = new Set(selectedValues || []);
  const rootRef = useRef(null);
  const [open, setOpen] = useState(false);
  const summaryText = selectedSet.size === 0
    ? placeholder
    : options
        .filter((option) => selectedSet.has(option.value))
        .map((option) => option.label)
        .join(', ');

  useEffect(() => {
    if (!open) return undefined;
    const handlePointerDown = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handlePointerDown);
    return () => document.removeEventListener('mousedown', handlePointerDown);
  }, [open]);

  return (
    <div className="pp-filter-field" ref={rootRef}>
      {label ? <span>{label}</span> : null}
      <div className={`pp-filter-multiselect${disabled ? ' is-disabled' : ''}`}>
        <button
          type="button"
          className="pp-filter-multiselect-trigger"
          onClick={() => {
            if (!disabled) setOpen((current) => !current);
          }}
          aria-haspopup="listbox"
          aria-expanded={open}
          disabled={disabled}
        >
          <span className="pp-filter-multiselect-trigger-text">{summaryText}</span>
          <span className="pp-filter-multiselect-trigger-icon" aria-hidden="true">{open ? '▲' : '▼'}</span>
        </button>
        {open ? (
          <div className="pp-filter-multiselect-menu" role="listbox" aria-multiselectable="true">
            <label className="pp-filter-checkbox-item">
              <input
                type="checkbox"
                checked={selectedSet.size === 0}
                onChange={() => onSelectAll()}
                disabled={disabled}
              />
              <span>Tümü</span>
            </label>
            {options.map((option) => (
              <label key={option.value} className="pp-filter-checkbox-item">
                <input
                  type="checkbox"
                  checked={selectedSet.has(option.value)}
                  onChange={() => onToggle(option)}
                  disabled={disabled}
                />
                <span>{option.label}</span>
              </label>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export function FilterRange({ label, minValue, maxValue, minPlaceholder, maxPlaceholder, onMinChange, onMaxChange }) {
  return (
    <div className="pp-filter-field">
      <span>{label}</span>
      <div className="pp-filter-range">
        <input
          type="number"
          min="0"
          step="any"
          inputMode="decimal"
          value={minValue}
          onInput={(event) => onMinChange(event.currentTarget.value)}
          placeholder={minPlaceholder}
        />
        <input
          type="number"
          min="0"
          step="any"
          inputMode="decimal"
          value={maxValue}
          onInput={(event) => onMaxChange(event.currentTarget.value)}
          placeholder={maxPlaceholder}
        />
      </div>
    </div>
  );
}
